// Generic, group-agnostic "About" blurb used as the default for every member
// who hasn't written their own. It prefills the profile About field and is the
// fallback shown on the member map when a member left their bio empty.
export const DEFAULT_ABOUT =
  "Hi there! 👋 I'm a proud member of this community. I love connecting with like-minded people, sharing ideas, and learning and growing together. Feel free to reach out and say hello!";
